export default {
  banner: {
    addTaxId: 'Have a {{children}}? Please add it to the Tax Policies section of your account.',
    buttonText: 'Submit my tax info',
    VAT: 'VAT ID',
    GST: 'GST ID',
  },
};
